// Seni bingkai gambar bermusim (SVG) - Destiny Junior
// viewBox 240x240, gambar bulat di tengah (cx 120, cy 120, r 80) => saiz bingkai = 1.5x saiz gambar

export const FRAME_META = {
  birthday: { label: "Hari Jadi", greeting: "Selamat Hari Jadi", bg: ["#fff1f7", "#fde7ff", "#e8f4ff"], accent: "#ec4899", text: "#9d174d" },
  raya_aidilfitri: { label: "Hari Raya Aidilfitri", greeting: "Selamat Hari Raya Aidilfitri", bg: ["#ecfdf3", "#fefce8", "#ecfdf5"], accent: "#15803d", text: "#14532d" },
  raya_aidiladha: { label: "Hari Raya Aidiladha", greeting: "Salam Aidiladha", bg: ["#ecfeff", "#fefce8", "#f0fdfa"], accent: "#0f766e", text: "#134e4a" },
  merdeka: { label: "Hari Merdeka", greeting: "Selamat Hari Merdeka", bg: ["#eff6ff", "#fff7ed", "#fef2f2"], accent: "#1d4ed8", text: "#1e3a8a" },
  tahun_baru: { label: "Tahun Baru", greeting: "Selamat Tahun Baru", bg: ["#fff7ed", "#fdf2f8", "#fefce8"], accent: "#d97706", text: "#78350f" },
};

const FONT = "Fredoka, Nunito, Arial, sans-serif";

const ribbon = (uid, text, c1, c2, txt = "#fff") => `
  <defs><linearGradient id="rb${uid}" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/></linearGradient></defs>
  <path d="M30 206 l14 -8 v24 l-14 -8 l8 -4z" fill="${c2}"/>
  <path d="M210 206 l-14 -8 v24 l14 -8 l-8 -4z" fill="${c2}"/>
  <path d="M44 198 Q120 186 196 198 V222 Q120 210 44 222 Z" fill="url(#rb${uid})" stroke="#fff" stroke-width="1.5"/>
  <text x="120" y="${text.length > 18 ? 213 : 214}" text-anchor="middle" font-family="${FONT}" font-weight="700" font-size="${text.length > 18 ? 10.5 : 13}" fill="${txt}">${text}</text>`;

const star = (x, y, r, fill) => {
  const pts = [];
  for (let i = 0; i < 10; i++) {
    const a = (Math.PI / 5) * i - Math.PI / 2;
    const rr = i % 2 ? r * 0.45 : r;
    pts.push(`${(x + rr * Math.cos(a)).toFixed(1)},${(y + rr * Math.sin(a)).toFixed(1)}`);
  }
  return `<polygon points="${pts.join(" ")}" fill="${fill}"/>`;
};

const crescent = (uid, x, y, r, fill) => `
  <defs><mask id="cm${uid}${x}"><circle cx="${x}" cy="${y}" r="${r}" fill="#fff"/><circle cx="${x + r * 0.45}" cy="${y - r * 0.2}" r="${r * 0.82}" fill="#000"/></mask></defs>
  <circle cx="${x}" cy="${y}" r="${r}" fill="${fill}" mask="url(#cm${uid}${x})"/>`;

const ketupat = (x, y, s) => `
  <line x1="${x}" y1="${y - s * 1.9}" x2="${x}" y2="${y - s}" stroke="#a16207" stroke-width="1.5"/>
  <g transform="translate(${x} ${y}) rotate(45)">
    <rect x="${-s * 0.72}" y="${-s * 0.72}" width="${s * 1.44}" height="${s * 1.44}" rx="2" fill="#22c55e" stroke="#166534" stroke-width="1.2"/>
    <path d="M${-s * 0.72} 0 H${s * 0.72} M0 ${-s * 0.72} V${s * 0.72}" stroke="#fde047" stroke-width="2.2"/>
    <path d="M${-s * 0.72} ${-s * 0.36} H${s * 0.72} M${-s * 0.72} ${s * 0.36} H${s * 0.72}" stroke="#bbf7d0" stroke-width="1"/>
  </g>
  <path d="M${x - 3} ${y + s} q3 ${s * 0.9} 0 ${s * 1.4} M${x + 3} ${y + s} q-3 ${s * 0.9} 0 ${s * 1.4}" stroke="#16a34a" stroke-width="1.6" fill="none"/>`;

const balloon = (x, y, c) => `
  <path d="M${x} ${y + 15} q-5 12 3 22 q6 8 -1 18" stroke="#94a3b8" stroke-width="1" fill="none"/>
  <ellipse cx="${x}" cy="${y}" rx="11" ry="14" fill="${c}"/>
  <ellipse cx="${x - 4}" cy="${y - 5}" rx="3" ry="4.5" fill="#fff" opacity=".55"/>
  <path d="M${x - 2.5} ${y + 14} h5 l-2.5 3z" fill="${c}"/>`;

const burst = (x, y, r, c) => {
  let s = "";
  for (let i = 0; i < 12; i++) {
    const a = (Math.PI / 6) * i;
    s += `<line x1="${(x + r * 0.35 * Math.cos(a)).toFixed(1)}" y1="${(y + r * 0.35 * Math.sin(a)).toFixed(1)}" x2="${(x + r * Math.cos(a)).toFixed(1)}" y2="${(y + r * Math.sin(a)).toFixed(1)}" stroke="${c}" stroke-width="2" stroke-linecap="round"/>`;
    s += `<circle cx="${(x + r * 1.15 * Math.cos(a)).toFixed(1)}" cy="${(y + r * 1.15 * Math.sin(a)).toFixed(1)}" r="1.6" fill="${c}"/>`;
  }
  return s;
};

const confetti = (colors) => {
  const spots = [[30, 100], [22, 140], [210, 104], [218, 150], [52, 30], [188, 26], [36, 176], [204, 182], [120, 8], [70, 14], [170, 12]];
  return spots.map(([x, y], i) => `<rect x="${x}" y="${y}" width="5" height="9" rx="1.5" fill="${colors[i % colors.length]}" transform="rotate(${(i * 37) % 90} ${x} ${y})"/>`).join("");
};

const ring = (r, w, color, dash = "", offset = 0) =>
  `<circle cx="120" cy="120" r="${r}" fill="none" stroke="${color}" stroke-width="${w}" ${dash ? `stroke-dasharray="${dash}" stroke-dashoffset="${offset}"` : ""}/>`;

const BUILDERS = {
  birthday: (uid) => `
    ${ring(88, 12, "#f472b6", "34 22", 0)}${ring(88, 12, "#60a5fa", "34 22", 56 / 3 * 1)}${ring(88, 12, "#facc15", "18 38", 8)}
    ${ring(81.5, 2, "#fff")}${ring(95, 2, "#fff", "2 6")}
    ${confetti(["#f472b6", "#60a5fa", "#facc15", "#34d399", "#a78bfa"])}
    ${balloon(30, 46, "#f472b6")}${balloon(48, 30, "#60a5fa")}${balloon(210, 46, "#facc15")}${balloon(192, 30, "#34d399")}
    <g transform="translate(120 26)"><path d="M-14 8 L0 -22 L14 8 Z" fill="#a78bfa" stroke="#fff" stroke-width="1.5"/><path d="M-9 -2 L9 -2 M-5 -11 L5 -11" stroke="#fde047" stroke-width="2.5"/><circle cx="0" cy="-23" r="4" fill="#facc15"/></g>
    ${ribbon(uid, "Selamat Hari Jadi!", "#f472b6", "#db2777")}`,
  raya_aidilfitri: (uid) => `
    ${ring(89, 13, "#15803d")}${ring(89, 3, "#facc15", "2 5")}${ring(81, 2.5, "#fde68a")}${ring(97, 2, "#86efac")}
    ${crescent(uid, 120, 24, 15, "#facc15")}${star(141, 18, 6, "#facc15")}${star(100, 14, 3.5, "#fde68a")}
    ${ketupat(36, 58, 13)}${ketupat(204, 58, 13)}${ketupat(62, 32, 9)}${ketupat(178, 32, 9)}
    ${[[26, 150], [214, 150], [40, 182], [200, 182]].map(([x, y]) => `<circle cx="${x}" cy="${y}" r="7" fill="#fdba74" opacity=".45"/><path d="M${x - 5} ${y + 3} q5 -12 10 0 z" fill="#f97316"/><ellipse cx="${x}" cy="${y + 4}" rx="7" ry="3" fill="#92400e"/>`).join("")}
    ${ribbon(uid, "Selamat Hari Raya", "#16a34a", "#166534", "#fef9c3")}`,
  raya_aidiladha: (uid) => `
    ${ring(89, 13, "#0f766e")}${ring(89, 3, "#facc15", "2 5")}${ring(81, 2.5, "#fde68a")}${ring(97, 2, "#5eead4")}
    ${crescent(uid, 120, 24, 15, "#facc15")}${star(141, 18, 6, "#facc15")}
    ${[[38, 56], [202, 56]].map(([x, y]) => `<line x1="${x}" y1="${y - 26}" x2="${x}" y2="${y - 13}" stroke="#a16207" stroke-width="1.5"/><rect x="${x - 9}" y="${y - 13}" width="18" height="26" rx="6" fill="#fef3c7" stroke="#b45309" stroke-width="2"/><path d="M${x} ${y - 13} V${y + 13} M${x - 9} ${y} H${x + 9}" stroke="#b45309" stroke-width="1"/><circle cx="${x}" cy="${y}" r="4" fill="#f59e0b"/><path d="M${x - 6} ${y + 13} h12 l-6 7z" fill="#b45309"/>`).join("")}
    ${star(28, 120, 5, "#facc15")}${star(212, 120, 5, "#facc15")}${star(46, 176, 4, "#fde68a")}${star(194, 176, 4, "#fde68a")}
    ${ribbon(uid, "Salam Aidiladha", "#0d9488", "#115e59", "#fef9c3")}`,
  merdeka: (uid) => `
    ${ring(89, 13, "#dc2626", "10 10")}${ring(89, 13, "#ffffff", "10 10", 10)}${ring(81.5, 2.5, "#1d4ed8")}${ring(96.5, 2.5, "#1d4ed8")}
    <g transform="translate(120 26)"><rect x="-26" y="-17" width="52" height="34" rx="5" fill="#1d4ed8" stroke="#fff" stroke-width="2"/></g>
    ${crescent(uid, 113, 26, 11, "#facc15")}${star(132, 26, 8, "#facc15")}
    ${burst(36, 46, 14, "#dc2626")}${burst(204, 46, 14, "#1d4ed8")}${burst(30, 168, 9, "#facc15")}${burst(210, 168, 9, "#dc2626")}
    ${ribbon(uid, "Selamat Hari Merdeka", "#2563eb", "#1e3a8a")}`,
  tahun_baru: (uid) => `
    ${ring(89, 12, "#f59e0b")}${ring(89, 3, "#fff7ed", "3 6")}${ring(81, 2.5, "#fbbf24")}${ring(97, 2, "#f9a8d4")}
    ${burst(38, 44, 18, "#ec4899")}${burst(202, 44, 18, "#f59e0b")}${burst(120, 16, 11, "#a855f7")}${burst(26, 156, 10, "#f59e0b")}${burst(214, 156, 10, "#ec4899")}
    ${star(70, 22, 5, "#fbbf24")}${star(170, 22, 5, "#fbbf24")}
    ${ribbon(uid, `Tahun Baru ${new Date().getMonth() >= 9 ? new Date().getFullYear() + 1 : new Date().getFullYear()}`, "#f59e0b", "#b45309")}`,
};

let _uid = 0;
export function frameSvg(key, uid) {
  const b = BUILDERS[key];
  if (!b) return "";
  const id = uid || `f${++_uid}`;
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="240" height="240">${b(id)}</svg>`;
}

export const frameDataUrl = (key) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(frameSvg(key, "c"))}`;

/** Minggu hari jadi: dari hari jadi hingga 6 hari selepasnya (waktu tempatan). */
export function isBirthdayWeek(dob, today = new Date()) {
  if (!dob || typeof dob !== "string") return false;
  const m = dob.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return false;
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  for (const yr of [t.getFullYear(), t.getFullYear() - 1]) {
    const b = new Date(yr, Number(m[2]) - 1, Number(m[3]));
    const diff = Math.round((t - b) / 86400000);
    if (diff >= 0 && diff <= 6) return true;
  }
  return false;
}

export function childAge(dob) {
  const m = (dob || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const t = new Date();
  let age = t.getFullYear() - Number(m[1]);
  if (t.getMonth() + 1 < Number(m[2]) || (t.getMonth() + 1 === Number(m[2]) && t.getDate() < Number(m[3]))) age -= 1;
  return age;
}
